module.exports = __webpack_public_path__ + "img/calendar-date.42f3240d.svg";